module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(this.user.roleName == 'Super Admin') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row dash-box"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('p', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.userCount))]), _vm._v(" "), _c('p', [_vm._v("User")])]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Users'
      }
    }
  }, [_c('div', {
    staticClass: "panel-footer bg-primary"
  }, [_vm._v("\n          More Info "), _c('i', {
    staticClass: "fa fa-arrow-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "total_investment_wrp"
  }, [(this.user.roleName == 'Admin') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row dash-box"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('p', {
    staticClass: "number"
  }, [_vm._v("\n                " + _vm._s(_vm.investedAmount ? _vm.investedAmount : '0') + "\n              ")]), _vm._v(" "), _c('p', [_vm._v("Total Investment Amount")])]), _vm._v(" "), _vm._m(1)])])])]) : _vm._e(), _vm._v(" "), (this.user.roleName == 'Admin') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row dash-box"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('p', {
    staticClass: "number"
  }, [_vm._v("\n                " + _vm._s(_vm.totalInvestmentAmount ? _vm.totalInvestmentAmount : '0') + "\n              ")]), _vm._v(" "), _c('p', [_vm._v("Current Investment Value")])]), _vm._v(" "), (_vm.totalInvestmentAmount !== 'No data') ? _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticStyle: {
      "margin-left": "-19px"
    },
    attrs: {
      "src": "/static/img/logo-usd.png",
      "alt": "Logo"
    }
  })]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (this.user.roleName == 'Admin') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row dash-box"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('p', {
    staticClass: "number",
    class: {
      positive: _vm.netProfitAndLoss > 0,
        negative: _vm.netProfitAndLoss < 0,
    }
  }, [_vm._v("\n                " + _vm._s(_vm.netProfitAndLoss ? _vm.netProfitAndLoss : '0') + "\n              ")]), _vm._v(" "), _c('p', [_vm._v("Unrealised Profit/Loss")])]), _vm._v(" "), (_vm.netProfitAndLoss !== 'No data') ? _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticStyle: {
      "margin-left": "-19px"
    },
    attrs: {
      "src": "/static/img/logo-usd.png",
      "alt": "Logo"
    }
  })]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (this.user.roleName == 'Admin') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row dash-box"
  }, [(_vm.net_pnl) ? _c('div', {
    staticClass: "col-sm-8"
  }, [_c('p', {
    staticClass: "number",
    class: {
      positive: _vm.net_pnl > 0, negative: _vm.net_pnl < 0
    }
  }, [_vm._v("\n                " + _vm._s(_vm.net_pnl ? _vm.net_pnl : '0') + "\n              ")]), _vm._v(" "), _c('p', [_vm._v("Net Profilt/Loss")])]) : _vm._e(), _vm._v(" "), (_vm.net_pnl !== 'No data') ? _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticStyle: {
      "margin-left": "-19px"
    },
    attrs: {
      "src": "/static/img/logo-usd.png",
      "alt": "Logo"
    }
  })]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (this.user.roleName == 'Admin') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row dash-box"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('p', {
    staticClass: "number",
    class: {
      positive: _vm.net_profit_percentage > 0,
        negative: _vm.net_profit_percentage < 0,
    }
  }, [_vm._v("\n                " + _vm._s(_vm.net_profit_percentage === 'No data' ?
    _vm.net_profit_percentage :
    (_vm.net_profit_percentage + "%")) + "\n              ")]), _vm._v(" "), _c('p', [_vm._v("Net Profit/Loss %")])]), _vm._v(" "), (_vm.net_profit_percentage !== 'No data') ? _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticStyle: {
      "margin-left": "-19px"
    },
    attrs: {
      "src": "/static/img/logo-usd.png",
      "alt": "Logo"
    }
  })]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (this.user.roleName == 'Admin') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row dash-box"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('p', {
    staticClass: "number"
  }, [_vm._v("\n                " + _vm._s(_vm.withdrawlAmount ? _vm.withdrawlAmount : '0') + "\n              ")]), _vm._v(" "), _c('p', [_vm._v("Withdrawl Amount")])]), _vm._v(" "), _vm._m(2)])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tablewrp"
  }, [(this.user.roleName == 'Admin') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('h3', [_vm._v("Investment History")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.history_table), function(data) {
    return (_vm.history_table.length > 0) ? _c('tr', [_c('td', [_vm._v("\n              " + _vm._s(data.createdAt) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(data.current_investment_value) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.pnl_value ? data.pnl_value : '0'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.net_pnl ? data.net_pnl : '0'))]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(data.net_profit_percentage ? ((data.net_profit_percentage) + "%") : '0') + "\n            ")])]) : _vm._e()
  }), 0)]), _vm._v(" "), (_vm.history_table.length === 0) ? _c('h4', {
    staticClass: "teext"
  }, [_vm._v("No Investment History Found")]) : _vm._e()]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticStyle: {
      "margin-left": "-19px"
    },
    attrs: {
      "src": "/static/img/user.png",
      "alt": "Logo"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticStyle: {
      "margin-left": "-19px"
    },
    attrs: {
      "src": "/static/img/logo-usd.png",
      "alt": "Logo"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticStyle: {
      "margin-left": "-19px"
    },
    attrs: {
      "src": "/static/img/logo-usd.png",
      "alt": "Logo"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Current Investment Value ($)")]), _vm._v(" "), _c('th', [_vm._v("Unrealised Profit/Loss ($)")]), _vm._v(" "), _c('th', [_vm._v("Net Profit/Loss ($)")]), _vm._v(" "), _c('th', [_vm._v("Net Profit/Loss %")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d416b89"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/dashboard/dashboard.vue
// module id = 1969
// module chunks = 1